// generic-client

import { useMutation } from '@apollo/client/react';
import * as Sentry from '@sentry/react';
import JwtManager from 'lib/JwtManager';
import { LOCAL_STORAGE } from '@constants';
import ENTERPRISE_LOGOUT_MUTATION from './EnterpriseLogoutMutation.graphql';

const useLogout = () => {
  const [logoutMutation] = useMutation(ENTERPRISE_LOGOUT_MUTATION);

  const logout = async () => {
    try {
      await logoutMutation();
      localStorage.setItem(LOCAL_STORAGE.SKIP_LOGIN_REDIRECTION, 'true');
      JwtManager.destroyJwt();
      Sentry.getCurrentScope().setUser(null);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  return { logout };
};

export default useLogout;
